module.exports = __webpack_public_path__ + "img/744d9d2.svg";